import { useT } from '../../lib/i18n.tsx'
import { Kbd } from '../../kit/Kbd.tsx'
import { Sheet } from '../../kit/Sheet.tsx'
import { shortcuts, type Shortcut } from '../keys.ts'
import { closeOverlay, useOverlay } from '../ui.ts'

function Keys({ keys }: { keys: string[] }) {
  const t = useT()
  if (keys[0] === 'g' && keys.length === 2) {
    return (
      <span className="inline-flex items-center gap-1 text-xs text-ink-faint">
        <Kbd keys={['g']} /> {t('common.shortcuts.then')} <Kbd keys={[keys[1] as string]} />
      </span>
    )
  }
  return <Kbd keys={keys} />
}

const GROUPS: { id: Shortcut['group']; label: 'common.shortcuts.global' | 'common.shortcuts.goTo' | 'common.shortcuts.list' }[] = [
  { id: 'global', label: 'common.shortcuts.global' },
  { id: 'goTo', label: 'common.shortcuts.goTo' },
  { id: 'list', label: 'common.shortcuts.list' },
]

/** The '?' sheet, rendered from the shortcut registry in keys.ts. */
export function ShortcutsSheet() {
  const t = useT()
  const open = useOverlay('shortcuts')
  const all = shortcuts()
  return (
    <Sheet open={open} onClose={closeOverlay} title={t('common.shortcuts.title')} description={t('common.shortcuts.description')}>
      <div className="flex flex-col gap-6">
        {GROUPS.map((g) => {
          const items = all.filter((s) => s.group === g.id)
          if (items.length === 0) return null
          return (
            <section key={g.id}>
              <h3 className="label-mono mb-2 text-ink-faint">{t(g.label)}</h3>
              <ul className="flex flex-col divide-y divide-line rounded-lg bg-raised ring-1 ring-line ring-inset">
                {items.map((s) => (
                  <li key={s.keys.join('+') + s.label} className="flex items-center justify-between gap-4 px-3 py-2">
                    <span className="min-w-0">
                      <span className="block truncate text-sm text-ink">{t(s.label)}</span>
                      {s.where && <span className="block text-xs text-ink-faint">{t(s.where)}</span>}
                    </span>
                    <Keys keys={s.keys} />
                  </li>
                ))}
              </ul>
            </section>
          )
        })}
      </div>
    </Sheet>
  )
}
